import { getCurrentSiteDomain } from '../utils/sites'
import ga from '../utils/ga'

export const reportEditCartEntryAttempt = ({ page }) => {
  ga('send', {
    hitType: 'pageview',
    page,
    title: 'Modal: Edit cart entry'
  })
}

export const reportCartSupportUpgrade = ({
  item,
  currentSite,
  license,
  price,
  support
}) => {
  const currentSiteDomain = getCurrentSiteDomain(currentSite)
  ga('ec:addProduct', {
    id: item.id,
    name: item.name,
    variant: license,
    category: `${currentSiteDomain}/${item.classification}`,
    brand: item.author_username,
    price,
    quantity: '1',
    dimension14: support
  })
  ga('ec:setAction', 'add')
  ga('send', 'event', 'Ecommerce', 'click', 'Search support upgrade')
}



// WEBPACK FOOTER //
// ./common/analytics/cartAnalytics.js